require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-fast-object-detection-with-fast-rcnn.json") })
        }
      }, "path---posts-fast-object-detection-with-fast-rcnn");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-fast-object-detection-with-fast-rcnn!./.cache/json/posts-fast-object-detection-with-fast-rcnn.json
// module id = 377
// module chunks = 231608221292675